import React from "react";
export var AccountDropdown = function AccountDropdown(props) {
  var _accountInfo$account;

  var handleAccoount = props.handleAccoount,
      accountInfo = props.accountInfo,
      authenticationState = props.authenticationState;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      return handleAccoount();
    }
  }, (_accountInfo$account = accountInfo.account) === null || _accountInfo$account === void 0 ? void 0 : _accountInfo$account.idToken.given_name));
};